import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../../api/generic/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const WoHParameterType = SearchDataTableType({
	request: BaseRequest({
		sortFields: constants.wholeHouse.additionalParameter.sortFields,
		columnFields: constants.wholeHouse.additionalParameter.columnFields,
		standardFilterFields: constants.wholeHouse.additionalParameter.osStandardFilterFields,
		dateFilterFields: constants.wholeHouse.additionalParameter.osDateFilterFields,
		stageStatusFilterFields: [] as const,
		booleanFilterFields: [] as const,
	}),
	columnFields: constants.wholeHouse.additionalParameter.columnFields,
	filterIds: constants.wholeHouse.additionalParameter.search.filterIds,
});
